export const newsItems = {
  url: '/api/breeder_app/news_items.json',
  defaultValue: {
    data: { items: [] }
  }
};
